import "./Shop.module.css";
import TrendMitraNavigationHeader from "@/reusable_sections/Header";
import ShopTitle from "./sections/ShopTitle";
import ShopContent from "./sections/ShopContent";
import TerminalFooter from "@/reusable_sections/Footer";
export default function ShopPage() {
  return <div>
      <TrendMitraNavigationHeader />
      <ShopTitle />
      <ShopContent />
      <TerminalFooter />
    </div>;
}